import {
  CHANGE_INPUT_BUDGET,
  CHANGE_INPUT_TERM,
  CHANGE_INPUT_POLICY,
  SET_CREATING_STRATEGY_LIST,
  SET_CREATING_INPUT,
  SET_CREATING_RESULT,
  SET_CREATING_INPUT_SET_COUNT,
  SET_CREATING_INPUT_SET_COUNT_ALL,
  RESET_CREATING_INPUT_SET_COUNT,
  EDIT_CREATING_ERROR_MESSAGES,
  SET_CREATING_STRATEGY_LIST_CACHE,
  CHANGE_CREATING_SIMULATION_TERM_ID,
  CHANGE_CREATING_SELECTED_STRATEGY_ID,
  SET_OMAKASE_PLAN_MASTER,
  SET_OMAKASE_PLAN_LOADING,
  FIND_OMAKASE_PLAN_STRATEGIES,
  INITIALIZE_OMAKASE_INPUT,
  SET_OMAKASE_PLAN_SUBMIT_PROCESSING,
  CREATE_OMAKASE_PLAN_REQUEST,
  GET_PORTFOLIOS_REQUEST_START_LOADING,
  GET_PORTFOLIOS_REQUEST_END_LOADING,
  GET_PORTFOLIOS_REQUEST,
  GET_PORTFOLIOS_SUCCESS,
  GET_PORTFOLIO_DETAIL_REQUEST_START_LOADING,
  GET_PORTFOLIO_DETAIL_REQUEST_END_LOADING,
  GET_PORTFOLIO_DETAIL_REQUEST,
  GET_PORTFOLIO_DETAIL_SUCCESS,
  CREATE_AP_GROUP_REQUEST,
  CREATE_AP_GROUP_REQUEST_START_LOADING,
  CREATE_AP_GROUP_REQUEST_END_LOADING,
  CHANGE_NAME_REQUEST,
  CHANGE_NAME_REQUEST_START_LOADING,
  CHANGE_NAME_REQUEST_END_LOADING,
  GET_OMAKASE_PLAN_MASTER_REQUEST,
  GET_OMAKASE_PLAN_MASTER_REQUEST_START_LOADING,
  GET_OMAKASE_PLAN_MASTER_REQUEST_END_LOADING,
  GET_OMAKASE_PLAN_MASTER_SUCCESS,
} from '../actionConstants/omakasePlanConstants';

export const changeOmakaseInputBudget = ({ budget }) => ({
  type: CHANGE_INPUT_BUDGET,
  payload: { inputForm: { budget } },
});
export const changeOmakaseInputTerm = ({ term }) => ({
  type: CHANGE_INPUT_TERM,
  payload: { inputForm: { term } },
});
export const changeOmakaseInputPolicy = ({ policy }) => ({
  type: CHANGE_INPUT_POLICY,
  payload: { inputForm: { policy } },
});
export const setOmakaseCreatingStrategyList = ({ strategyList }) => ({
  type: SET_CREATING_STRATEGY_LIST,
  payload: { creating: { strategyList } },
});
export const setOmakaseCreatingInput = ({ input }) => ({
  type: SET_CREATING_INPUT,
  payload: { creating: { input } },
});
export const setOmakaseCreatingResult = ({ result }) => ({
  type: SET_CREATING_RESULT,
  payload: { creating: { result } },
});
export const setOmakaseCreatingInputSetCount = ({ strategyId, count }) => ({
  type: SET_CREATING_INPUT_SET_COUNT,
  payload: { creating: { inputSetCount: { strategyId, count } } },
});
export const setOmakaseCreatingInputSetCountAll = ({ inputSetCount }) => ({
  type: SET_CREATING_INPUT_SET_COUNT_ALL,
  payload: { creating: { inputSetCount } },
});
export const resetOmakaseCreatingInputSetCount = () => ({
  type: RESET_CREATING_INPUT_SET_COUNT,
});
export const addOmakaseCreatingErrorMessage = ({ inputName, errorMessage }) => ({
  type: EDIT_CREATING_ERROR_MESSAGES,
  payload: { editor: (errorMessages) => [...errorMessages, { inputName, errorMessage }] },
});
export const removeOmakaseCreatingErrorMessageByInputName = ({ inputName: key }) => ({
  type: EDIT_CREATING_ERROR_MESSAGES,
  payload: { editor: (errorMessages) => errorMessages.filter(({ inputName }) => inputName !== key) },
});
export const removeOmakaseCreatingErrorMessageByMessage = ({ errorMessage: key }) => ({
  type: EDIT_CREATING_ERROR_MESSAGES,
  payload: { editor: (errorMessages) => errorMessages.filter(({ errorMessage }) => errorMessage !== key) },
});
export const clearOmakaseCreatingErrorMessage = () => ({
  type: EDIT_CREATING_ERROR_MESSAGES,
  payload: { editor: (_) => [] },
});
export const setOmakaseCreatingStrategyListCache = ({ simulationTermId, strategyList }) => ({
  type: SET_CREATING_STRATEGY_LIST_CACHE,
  payload: { simulationTermId, strategyList },
});
export const changeOmakaseCreatingSimulationTermId = ({ simulationTermId }) => ({
  type: CHANGE_CREATING_SIMULATION_TERM_ID,
  payload: { simulationTermId },
});
export const changeOmakaseCreatingSelectedStrategyId = ({ strategyId }) => ({
  type: CHANGE_CREATING_SELECTED_STRATEGY_ID,
  payload: { strategyId },
});
export const setOmakaseInputMaster = ({ omakasePlanMaster }) => ({
  type: SET_OMAKASE_PLAN_MASTER,
  payload: { omakasePlanMaster },
});
export const setOmakasePlanLoading = ({ loading }) => ({
  type: SET_OMAKASE_PLAN_LOADING,
  payload: { loading },
});
export const findOmakasePlanStrategies = ({ selectedOmakasePlan }) => ({
  type: FIND_OMAKASE_PLAN_STRATEGIES,
  payload: { selectedOmakasePlan },
});
export const initializeOmakaseInput = () => ({
  type: INITIALIZE_OMAKASE_INPUT,
});
export const setOmakasePlanSubmitProcessing = ({ isProcessing }) => ({
  type: SET_OMAKASE_PLAN_SUBMIT_PROCESSING,
  payload: { isProcessing },
});
export const createOmakasePlan = ({ serviceId, name, strategyList, successCallback, failureCallback }) => ({
  type: CREATE_OMAKASE_PLAN_REQUEST,
  payload: { serviceId, name, strategyList, successCallback, failureCallback },
});
export const getPortfoliosRequest = () => ({ type: GET_PORTFOLIOS_REQUEST });
export const getPortfoliosRequestStartLoading = () => ({ type: GET_PORTFOLIOS_REQUEST_START_LOADING });
export const getPortfoliosRequestEndLoading = () => ({ type: GET_PORTFOLIOS_REQUEST_END_LOADING });
export const getPortfoliosSuccess = ({ portfolios }) => ({
  type: GET_PORTFOLIOS_SUCCESS,
  payload: { portfolios },
});

export const getPortfolioDetailRequest = ({ portfolioId, termId }) => ({
  type: GET_PORTFOLIO_DETAIL_REQUEST,
  payload: { portfolioId, termId },
});
export const getPortfolioDetailRequestStartLoading = () => ({
  type: GET_PORTFOLIO_DETAIL_REQUEST_START_LOADING,
});
export const getPortfolioDetailRequestEndLoading = () => ({
  type: GET_PORTFOLIO_DETAIL_REQUEST_END_LOADING,
});
export const getPortfolioDetailSuccess = ({ portfolioDetail }) => ({
  type: GET_PORTFOLIO_DETAIL_SUCCESS,
  payload: { portfolioDetail },
});

export const createOmakasePlanApGroupRequest = (payload) => ({
  type: CREATE_AP_GROUP_REQUEST,
  payload,
});
export const createOmakasePlanApGroupRequestStartLoading = () => ({
  type: CREATE_AP_GROUP_REQUEST_START_LOADING,
});
export const createOmakasePlanApGroupRequestEndLoading = () => ({ type: CREATE_AP_GROUP_REQUEST_END_LOADING });

export const changeOmakasePlanNameRequest = (payload) => ({
  type: CHANGE_NAME_REQUEST,
  payload,
});
export const changeOmakasePlanNameRequestStartLoading = () => ({
  type: CHANGE_NAME_REQUEST_START_LOADING,
});
export const changeOmakasePlanNameRequestEndLoading = () => ({ type: CHANGE_NAME_REQUEST_END_LOADING });

export const getOmakasePlanMasterRequest = ({ successCallback, failureCallback }) => ({
  type: GET_OMAKASE_PLAN_MASTER_REQUEST,
  payload: { successCallback, failureCallback },
});
export const getOmakasePlanMasterRequestStartLoading = () => ({
  type: GET_OMAKASE_PLAN_MASTER_REQUEST_START_LOADING,
});
export const getOmakasePlanMasterRequestEndLoading = () => ({
  type: GET_OMAKASE_PLAN_MASTER_REQUEST_END_LOADING,
});
export const getOmakasePlanMasterSuccess = ({ omakasePlanMaster }) => ({
  type: GET_OMAKASE_PLAN_MASTER_SUCCESS,
  payload: { omakasePlanMaster },
});
